import { useTranslation } from 'react-i18next';

import styles from './Footer.module.scss';
import { getCurrentYear } from 'app/helpers/getCurrentYear';
import { Link, NavLink } from 'react-router-dom';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = getCurrentYear();
  const supportEmail: string = window._env_?.SUPPORT_EMAIL;

  const title = <>SiAIS</>;

  return (
    <div className={styles.footer}>
      <div className={styles.footer_body}>
        <span className={styles.footer_col}>
          {title}, {currentYear}.
        </span>
        <span className={styles.footer_nav}>
          <NavLink className={styles.link} to="/">
            <span>{t('Home')}</span>
          </NavLink>
          <Link className={styles.link} to={`mailto:${supportEmail}`}>
            {t('Support')}
          </Link>
        </span>
      </div>
    </div>
  );
};
